import { clearOutlookAttachmentFileLinks } from '../attachment-file-links'
import { clearOutlookPaneStates } from '../state'

// Thread navigation may persist after unmount; logout ends that permission separately.
let logoutGeneration = 0

export function getOutlookLogoutGeneration(): number {
  return logoutGeneration
}

export function clearOutlookLocalData(): void {
  logoutGeneration += 1
  clearOutlookPaneStates()
  clearOutlookAttachmentFileLinks()
}
